module.exports = __webpack_public_path__ + "assets/img/1263.2f07687b.png";